import React, { useEffect, useState } from 'react'
//import { useParams } from 'react-router-dom'
import QRCode from "react-qr-code";
import useMountEffect from '../utils/hooks/useMountEffect'

export function printDiv(divId) {
    var printContents = document.getElementById(divId).innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
}

const InventoryActionPagePrint = () => {
    //const { printcode } = useParams()
    const [printCodes, setPrintCodes] = useState([])
    const [print, setPrint] = useState(false)
    useEffect(() => {
        setTimeout(() => {
            setPrint(true)
        }, 2000);
    }, [])

    useEffect(() => {
        if (print) {
            //window.print()
            printDiv('printableArea')

            window.close()
        }
    }, [print, setPrint])

    const checkSessionStorage = async () => {
        if (sessionStorage.getItem('printBarcodeNumbers')) {
            let printBarcodeNumbers = JSON.parse(
                sessionStorage.getItem('printBarcodeNumbers')
            )
            sessionStorage.removeItem('printBarcodeNumbers')
            if (printBarcodeNumbers) {
                setPrintCodes(printBarcodeNumbers)
            }
        }
    }
    useMountEffect(() => {
        checkSessionStorage()
    })

    return (
        <>
            <div id="printableArea">
                <div className="mb-5" />
                {printCodes.map((code, index) =>
                    <React.Fragment key={index} >
                        <div>
                            <QRCode value={code} size={128} />
                        </div>
                        <div className="mb-5" />
                    </React.Fragment >
                )}
            </div>
        </>
    )
}

export default InventoryActionPagePrint
